import React, { useState, useEffect } from 'react';

import { APP_URL } from 'types';
import {
  SideNavLink,
  SideNavMenu,
  SideNavMenuItem
} from 'carbon-components-react';
import {
  WatsonHealthMagnify16,
  ReportData16,
  Tools16,
  UserMultiple16,
  Api16,
  Bullhorn16
} from '@carbon/icons-react';
import { useHistory } from 'react-router-dom';

export const LeftNavSysAdmin: React.FC<{}> = () => {
  const history = useHistory();
  const [pathname, setPathname] = useState<string>(history?.location?.pathname);

  useEffect(() => {
    history && setPathname(history.location?.pathname);
  }, [history]);
  return (
    <>
      <div className="divider" />
      {/* Reporting */}
      <SideNavLink
        aria-current={pathname === APP_URL.REPORTS ? 'page' : undefined}
        renderIcon={ReportData16}
        onClick={() => history.push(`${APP_URL.REPORTS}`)}
      >
        Reporting
      </SideNavLink>
      {/* All Enquiry History */}
      <SideNavLink
        aria-current={
          pathname === APP_URL.ALL_ENQUIRIY_HISTORY ? 'page' : undefined
        }
        renderIcon={WatsonHealthMagnify16}
        onClick={() => history.push(`${APP_URL.ALL_ENQUIRIY_HISTORY}`)}
      >
        Enquiry history
      </SideNavLink>
      <div className="divider" />

      <SideNavLink
        renderIcon={Bullhorn16}
        aria-current={
          pathname === APP_URL.MANAGE_ANNOUNCEMENTS ? 'page' : undefined
        }
        onClick={() => history.push(APP_URL.MANAGE_ANNOUNCEMENTS)}
      >
        Manage announcements
      </SideNavLink>

      <SideNavLink
        renderIcon={UserMultiple16}
        aria-current={pathname === APP_URL.USERS_ADMIN ? 'page' : undefined}
        onClick={() => history.push(APP_URL.USERS_ADMIN)}
      >
        Manage support users
      </SideNavLink>
      <SideNavLink
        renderIcon={Api16}
        aria-current={
          pathname === APP_URL.PREMIUM_FEATURES ? 'page' : undefined
        }
        onClick={() => history.push(APP_URL.PREMIUM_FEATURES)}
      >
        Premium features
      </SideNavLink>
      <div className="divider" />
      {/* Support tools */}
      <SideNavMenu
        renderIcon={Tools16}
        title="Support tools"
        defaultExpanded={
          pathname.includes(APP_URL.SUPPORT) ||
          pathname.includes(APP_URL.AOI_VIEWER)
        }
      >
        <SideNavMenuItem
          isActive={pathname.includes(APP_URL.SEARCH_EMAILS)}
          onClick={() => history.push(`${APP_URL.SEARCH_EMAILS}`)}
        >
          Email history
        </SideNavMenuItem>
        <SideNavMenuItem
          isActive={pathname.includes(APP_URL.SEARCH_SUPPORT_USERS)}
          onClick={() => history.push(`${APP_URL.SEARCH_SUPPORT_USERS}`)}
        >
          Users search
        </SideNavMenuItem>
        <SideNavMenuItem
          isActive={pathname.includes(APP_URL.AOI_VIEWER)}
          onClick={() => history.push(`${APP_URL.AOI_VIEWER}`)}
        >
          AOI viewer
        </SideNavMenuItem>
      </SideNavMenu>

      {/* Integrations */}
    </>
  );
};

export default LeftNavSysAdmin;
